module.exports = "/assets/images/5ae4d06eec0be12339745548f667404b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_warning.svg
// module id = MmxR
// module chunks = 0